import React, { useState } from "react";
import { Badge, DefaultButton } from "../../../../../UI toolkit/Button/Button";
import { Modal } from "../../../../../UI toolkit/Modal/Modal";
import { H1, H5, H6, P, SubHeader } from "../../../../../UI toolkit/Text/Text";
import ic_sent_icon from "../../../../../assets/images/ic-sent-coin.svg";
import ic_left_icon from "../../../../../assets/images/ic-left-arrow.svg";
import { connect } from "react-redux";
import moment from "moment";

import {
  capitalizeFirstLetter,
  formatLargeNumber,
} from "../../../../../utils/specialFunctions";
import { P2PModalStyle } from "./UserP2P.styled";

const UserP2PAdModal = ({ width, border, closeModalCallback, ad, user }) => {
  return (
    <div>
      <Modal width={width} border={border} callback={closeModalCallback}>
        {ad ? (
          <P2PModalStyle>
            <div className="-mx-8">
              <div className="flex items-center justify-between px-6 py-3 border-bottom bg-white">
                <div className="flex items-center">
                  <div>
                    <img
                      src={
                        ad.action.toLowerCase() === "buy"
                          ? ic_sent_icon
                          : ad.action.toLowerCase() === "sell"
                          ? ic_left_icon
                          : ""
                      }
                      alt="img"
                    />
                  </div>
                  &nbsp;
                  <div>
                    <H6
                      color={"#112E46"}
                      className="text-center"
                      fontWeight="700"
                    >
                      {ad.action === "buy"
                        ? "Buy Ad"
                        : ad.action === "sell"
                        ? "Sell Ad"
                        : null}
                    </H6>
                  </div>
                </div>

                <div className="">
                  <Badge
                    color={ad.is_active ? "#335F71" : "#337138"}
                    bg={ad.is_active ? "#D1F7C4" : "#FFDCE5"}
                  >
                    {ad.is_active ? "Active" : "Inactive"}
                  </Badge>
                </div>
              </div>

              <div className="flex px-6 pt-6 pb-4 border-bottom">
                <div className="w-4/12">
                  <div className="">
                    <SubHeader
                      fontSize="12px"
                      color={"#7C8191"}
                      fontWeight="500"
                    >
                      MERCHANT
                    </SubHeader>
                  </div>
                </div>

                <div className="w-8/12">
                  <div className="mb-2">
                    <P fontSize="16px" color={"#374072"} fontWeight="500">
                      {`${user.firstName} ${user.lastName}`}
                    </P>
                  </div>

                  <div className="">
                    <P fontSize="13px" color={"#374072"} fontWeight="500">
                      {user.email}
                    </P>
                  </div>

                  <div className="">
                    <P fontSize="13px" color={"#848A8E"} fontWeight="500">
                      {ad?.p2p_profile?.username}
                    </P>
                  </div>
                </div>
              </div>
              <div className="flex px-6 pt-6 pb-4 border-bottom">
                <div className="w-4/12">
                  <div className="">
                    <SubHeader
                      fontSize="12px"
                      color={"#7C8191"}
                      fontWeight="500"
                    >
                      PRICE TYPE
                    </SubHeader>
                  </div>
                </div>

                <div className="w-8/12">
                  <P fontSize="14px" color={"#374072"} fontWeight="300">
                    {capitalizeFirstLetter(ad.price_type)}
                  </P>
                </div>
              </div>
              {ad.price_type === "fixed" && (
                <div className="flex px-6 pt-6 pb-4 border-bottom">
                  <div className="w-4/12">
                    <div className="">
                      <SubHeader
                        fontSize="12px"
                        color={"#7C8191"}
                        fontWeight="500"
                      >
                        AD PRICE
                      </SubHeader>
                    </div>
                  </div>

                  <div className="w-8/12">
                    <P fontSize="16px" color={"#4B4F52"} fontWeight="500">
                      NGN
                      {Number(ad.price).toFixed(2).toLocaleString()}
                      /USDT
                    </P>
                  </div>
                </div>
              )}
              <div className="flex px-6 pt-6 pb-4 border-bottom">
                <div className="w-4/12">
                  <div className="">
                    <SubHeader
                      fontSize="12px"
                      color={"#7C8191"}
                      fontWeight="500"
                    >
                      QUANTITY
                    </SubHeader>
                  </div>
                </div>

                <div className="w-8/12">
                  <P fontSize="16px" color={"#4B4F52"} fontWeight="500">
                    {ad.action === "sell"
                      ? ad.source_currency
                      : ad.action === "buy"
                      ? ad.destination_currency
                      : ""}
                    {Number(ad.quantity).toFixed(2).toLocaleString()}
                  </P>
                </div>
              </div>
              <div className="flex px-6 pt-6 pb-4 border-bottom">
                <div className="w-4/12">
                  <div className="">
                    <SubHeader
                      fontSize="12px"
                      color={"#7C8191"}
                      fontWeight="500"
                    >
                      LIMIT
                    </SubHeader>
                  </div>
                </div>

                <div className="w-8/12">
                  <P fontSize="16px" color={"#4B4F52"} fontWeight="500">
                    NGN {formatLargeNumber(ad.lower_limit)} -
                    {formatLargeNumber(ad.upper_limit)}
                  </P>
                </div>
              </div>

              <div className="flex px-6 pt-6 pb-4 border-bottom">
                <div className="w-4/12">
                  <div className="">
                    <SubHeader
                      fontSize="12px"
                      color={"#7C8191"}
                      fontWeight="500"
                    >
                      id
                    </SubHeader>
                  </div>
                </div>

                <div className="w-8/12">
                  <div className="mb-1">
                    <P fontSize="16px" color={"#374072"} fontWeight="700">
                      {ad.id}
                    </P>
                  </div>

                  <div className="my-1">
                    <P fontSize="13px" color={"#374072"} fontWeight="500">
                      {new Date(ad.created_at).toDateString()}
                    </P>
                  </div>

                  <div className="mt-1">
                    <P fontSize="13px" color={"#374072"} fontWeight="500">
                      {new Date(ad.created_at).toLocaleTimeString()}
                    </P>
                  </div>
                </div>
              </div>
            </div>
          </P2PModalStyle>
        ) : (
          <P fontSize="13px" color={"#374072"} fontWeight="500">
            Loading.....
          </P>
        )}
      </Modal>
    </div>
  );
};

// Redux store mapstatetoprops and mapdispatchtoprops
const mapStateToProps = (state) => {
  return {
    loading: state.verification.loading,
    error: state.verification.error,
  };
};

// Link Actions to components
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(UserP2PAdModal);
